// Set a variable for our button element (scrool down).
var buttonScrollDdown = document.getElementById('js-scroll-down');

// check if page has scrool down button
if (buttonScrollDdown) {
  // var packageSectionOffset = packageSection.top;
  // scroll down to next section on click
  buttonScrollDdown.addEventListener('click', function () {
    var packageSection = document.querySelector('.subscription-packages').getBoundingClientRect();
    var bodyRect = document.body.getBoundingClientRect();
    var packageSectionOffset = packageSection.top - bodyRect.top;
    window.scroll({
      top: packageSectionOffset,
      left: 0,
      behavior: 'smooth'
    });
  });
}
